export default "/kiban/_next/static/images/login_image_2-8ac2fae3f6b4465232044ec3b9c7d3b8.jpg";